import Loadable from '../../components/loadable';

const SignUpForm = Loadable({
  loader: () => import('../../components/sign_up_form'),
});

angular.module('shared').value('SignUpForm', SignUpForm);
